import {

    SET_ERROR, SET_EVENT,
    SET_LOADING,
    SET_RESET
} from "./mutation_types";

export default {
    [SET_EVENT](state,event){
        state.event=event.data;
    },

    [SET_ERROR](state, error) {
        state.error = error;
    },
    [SET_LOADING](state, loading) {
        state.loading = loading;
    },
    [SET_RESET](state) {
        state.mornsunResource = [];
        state.resource = [];
        state.chinaResource = [];
        state.mouserResource = [];
    }
};

